import { useStaticQuery, graphql } from 'gatsby';

const useCompany = () => {
  const { companies } = useStaticQuery(graphql`
    fragment LabelFragment on STRAPI_LABEL {
      id
      name
      link
      image {
        name
        url
        width
        height
        ext
        localFile {
          childImageSharp {
            gatsbyImageData(
              layout: FIXED,
              width: 90,
              quality: 100,
              placeholder: BLURRED
            )
          }
        }
      }
      alternativeImage {
        name
        url
        width
        height
        ext
        localFile {
          childImageSharp {
            gatsbyImageData(
              layout: FIXED,
              width: 90,
              quality: 100,
              placeholder: BLURRED
            )
          }
        }
      }
    }
    query Strapi4Companies {
      companies: allStrapiCompany(sort: { createdAt: ASC }) {
        nodes {
          id
          documentId
          strapiId: strapi_id
          name
          email
          tel
          telWithCountryCode: tel(withCountryCode: "nl")
          tel2
          tel2WithCountryCode: tel2(withCountryCode: "nl")
          vehicleSalesTel
          vehicleSalesTelWithCountryCode: vehicleSalesTel(withCountryCode: "nl")
          fax
          street
          houseNumber
          postcode
          city
          kvk
          btw
          iban
          googleMapsPanoId

          logo {
            name
            url
            width
            height
            localFile {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED,
                  width: 320,
                  quality: 100,
                  placeholder: BLURRED
                )
              }
            }
          }

          image {
            name
            url
            width
            height
            localFile {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED,
                  width: 800,
                  quality: 100,
                  placeholder: BLURRED
                )
              }
            }
          }

          squareImage: image {
            name
            url
            width
            height
            localFile {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  width: 142
                  height: 142
                  quality: 100
                  placeholder: BLURRED
                )
              }
            }
          }

          labels {
            ...LabelFragment
          }
        }
      }
    }
  `);

  return companies.nodes;
};

export default useCompany;
